import { TransparentCard } from './TransparentCard';
import heart from "@/assets/hearts.png";
import classroomPhoto from "@/assets/classroom.webp";
import feedingAmerica from "@/assets/feedingamerica.png";
import { useState } from 'react';
import { useIsLocationAllowed } from '@/hooks/useIsLocationAllowed';
import { openUrl } from '@/bridge/openUrl';


export function SkillScratchCard() {
  const [isClicking, setIsClicking] = useState(false);
  const [isLocationAllowed] = useIsLocationAllowed();
  
  const handleClick = () => {
    if (isClicking) return;
    
    setIsClicking(true);
    openUrl('https://www.feedingamerica.org/hunger-in-america');
    

    setTimeout(() => {
      setIsClicking(false);
    }, 0);
  };

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div 
      className={'w-full max-w-md mx-auto btn-bounce-subtle'} 
      onClick={handleClick}
    >
      <TransparentCard
        backgroundImage={classroomPhoto}
      >
        <div className="text-white">
          <h2 className="text-2xl font-bold mb-1">{`Scratch ${isLocationAllowed?.locationName}`}</h2>
          <h1 className="text-4xl font-bold mb-3">
            Proudly supports <br />
            meals for kids
          </h1>
          
          <div className="flex items-center gap-4">
            <div className="bg-white py-1 px-3 rounded-md">
              <img 
                src={feedingAmerica}
                alt="Feeding America" 
                className="h-10" 
              />
            </div>
            <img src={heart} alt='heart' className='h-7 ml-1'/>
          </div>
        </div>
      </TransparentCard>
    </div>
  );
}